import * as React from 'react'
import DriverDataStage from './DriverDataStage'
import CardsStage from './CardsStage'
import IdStage from './IdStage'
import PermissionsStage from './PersmissionsStage'
import { Divider } from '../../shared/Divider'
const FullFormBasic = () => {
  return (
    <section className="tw-space-y-6 tw-p-6">
      <DriverDataStage />
      <Divider />
      <CardsStage />
      <Divider />
      <IdStage />
      <Divider />
      <PermissionsStage />
    </section>
  )
}

export default FullFormBasic
